import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import React, {MouseEvent} from 'react';
import cx from 'classnames';
import style from '../styles/formInputButton.module.scss';

type Props = {
    icon: PriorityIcon;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    isPrimary?: boolean;
    componentClasses?: string;
    size?: 'small' | 'default';
};

export const FormInputButton = ({
    icon,
    onClick,
    isPrimary,
    componentClasses,
    size = 'default'
}: Props) => {
    return (
        <div className={cx(style.button, {[style.primary]: isPrimary}, componentClasses)}>
            <Icon
                size={size}
                skin="standart"
                icon={icon}
                hoverable
                onClick={onClick}
                componentClasses={style.icon}
            />
        </div>
    );
};
